import { Routes } from '@angular/router';
import { DemoPageComponent } from '../pages/demo-page/demo-page.component';
import { proxyAuthGuard } from './guards/proxy-auth.guard';

export const routes: Routes = [
    { path: '', redirectTo: '/demo', pathMatch: 'full' },
    { path: 'demo', component: DemoPageComponent, canActivate: [proxyAuthGuard] }
];
